<div class="container">
    <h1 class="mt-3">Formulario</h1>
    <div class="row">
        <div class="row">
            <div class="row mb-5">
                <div class="col-6">
                    <div class="form-floating">
                        <select class="form-select" id="floatingSelect" aria-label="Floating label select example" (change)="loadFormConfig($event)">
                            @for (function of functions; track $index) {
                                <option [value]="function">{{ function }}</option>
                            }
                        </select>
                        <label for="floatingSelect">Selección de función</label>
                      </div>
                </div>
            </div>
            @if (!loading) {
                <app-formulario
                    [title]="titleForm"
                    [buttons]="buttons"
                    [fields]="fields"
                    [type]="item"
                    [functionSelected]="functionSelected">
                </app-formulario>
            }
        </div>
    </div>
</div>